import { supabaseClient } from "./client";
import { CommissionComment, CommissionCommentInsert, CommissionCommentWithUser } from "@revelate/types/comments";

/**
 * Get comments for a specific commission
 */
export const getCommissionComments = async (commissionId: number): Promise<CommissionCommentWithUser[]> => {
  const { data, error } = await supabaseClient
    .from("commission_comments")
    .select(`
      *,
      user:user_id(
        id,
        first_name,
        last_name,
        email,
        avatar_url
      )
    `)
    .eq("commission_id", commissionId)
    .order("created_at", { ascending: true });

  if (error) {
    console.error("Error fetching commission comments:", error);
    throw error;
  }

  return data as unknown as CommissionCommentWithUser[];
};

/**
 * Add a comment to a commission
 */
export const addCommissionComment = async (comment: Omit<CommissionCommentInsert, "created_at" | "updated_at">): Promise<CommissionComment> => {
  const { data, error } = await supabaseClient
    .from("commission_comments")
    .insert(comment)
    .select()
    .single();

  if (error) {
    console.error("Error adding commission comment:", error);
    throw error;
  }

  return data;
};

/**
 * Delete a comment from a commission
 */
export const deleteCommissionComment = async (commentId: number): Promise<void> => {
  const { error } = await supabaseClient
    .from("commission_comments")
    .delete()
    .eq("id", commentId);

  if (error) {
    console.error("Error deleting commission comment:", error);
    throw error;
  }
};
